import './styles.scss';

import {
  faChevronRight,
  faGear,
  faGraduationCap,
  faKey,
  faSliders,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MenuItem, MenuList } from '@mui/material';
import { useContext, useEffect, useState } from 'react';

import ImmersiveAppBar from '../../components/appbar/appbar';
import ImmersiveFooter from '../../components/footer/footer';
import { GlobalContext, GlobalTabsKeysEnum } from '../../providers/global-provider';

import AccountManagement from './account-management';
import ApiKeys from './api-keys';
import KnowledgeBase from './knowledge-base';
import MySettings from './my-settings';

const SETTINGS_OPTIONS_GROUPS = [
  {
    title: 'Personal',
    items: [{ id: 'my_settings', label: 'My Settings', icon: faSliders }],
  },
  {
    title: 'Company',
    items: [
      { id: 'account_management', label: 'Account management', icon: faGear },
      { id: 'api_keys', label: 'API Keys', icon: faKey },
    ],
  },
  {
    title: 'Help',
    items: [{ id: 'knowledge_base', label: 'Knowledge Base', icon: faGraduationCap }],
  },
];

const Settings = () => {
  const { setCurrentTab } = useContext(GlobalContext);
  const [currentSetting, setCurrentSetting] = useState<string>('my_settings');

  useEffect(() => {
    setCurrentTab(GlobalTabsKeysEnum.settings);
  }, []);

  const renderLeftBar = () => {
    const renderMenuItem = (item: any) => {
      return (
        <MenuItem
          className="group-item"
          key={item.id}
          onClick={() => {
            setCurrentSetting(item.id);
          }}
        >
          <FontAwesomeIcon icon={item.icon} className="icon" />
          <span>{item.label}</span>
          <FontAwesomeIcon icon={faChevronRight} className="icon" />
        </MenuItem>
      );
    };

    return (
      <div className="left-bar">
        {SETTINGS_OPTIONS_GROUPS.map((group, index) => (
          <div className="group" key={index}>
            <span className="group-title">{group.title}</span>
            <MenuList>{group.items.map((item) => renderMenuItem(item))}</MenuList>
          </div>
        ))}
      </div>
    );
  };

  const renderSettingPage = () => {
    switch (currentSetting) {
      case 'my_settings':
        return <MySettings />;
      case 'account_management':
        return <AccountManagement />;
      case 'api_keys':
        return <ApiKeys />;
      case 'knowledge_base':
        return <KnowledgeBase />;
      default:
        return null;
    }
  };

  return (
    <>
      <ImmersiveAppBar />
      <div className="settings-container">
        <h1 className="setting-title">Settings</h1>
        <div className="settings-content">
          {renderLeftBar()}
          {renderSettingPage()}
        </div>
      </div>
      <ImmersiveFooter renderConnectionStatus={false} />
    </>
  );
};

export default Settings;
